import CTNButton from '@ctn/ui/components/ctn-button';
import CTNInput from '@ctn/ui/components/ctn-input';
import { type ReactElement } from 'react';

import { useEmpresa } from '@/context/empresa.context';

import DetalleAlta from '../components/detalleAlta';
import ServiciosYNotificaciones from '../components/serviciosYNotificaciones';

const EmpresaShow = (): ReactElement => {
	const { control, emisor, setIsEdit } = useEmpresa();

	return (
		<section className="[ c-pnp-box c-pnp-box--border c-pnp-box--breakout ] [ u-flow-border ]">
			<header className="[ c-pnp-box__header o-splitter ]">
				<h3 className="c-pnp-heading-h3">
					{ emisor?.nombre }
				</h3>
				<CTNButton
					label="Editar"
					variant="ghost"
					size="size-40"
					mode='secondary'
					onClick={() => setIsEdit(true)}
				/>
			</header>
			<form className="c-pnp-box__body">
				<div className="o-splitter">
					<h4 className="c-pnp-heading-h4">Datos de la empresa</h4>
				</div>
				<div className="[ o-grid ] [ u-mt-16 u-flow ]">
					<div className="[ o-grid__row ]">
						<CTNInput
							noFeedBack
							displayOnly
							condensed
							type="text"
							classNameField="o-grid__col-4 o-grid__col-4@portrait "
							name="emisor.nif"
							label="NIF"
							control={control}
							maxLength={9}
						/>						
						<CTNInput
							noFeedBack
							displayOnly
							condensed
							type="text"
							classNameField="o-grid__col-4 o-grid__col-4@portrait"
							name="emisor.tipoSector.descripcion"
							label="Sector"
							control={control}
						/>
					</div>
					<div className="[ o-grid__row ]  [ c-pnp-company-data__readonly-row ]">
						<CTNInput
							noFeedBack
							displayOnly
							condensed
							type="text"
							classNameField="o-grid__col-12 o-grid__col-4@portrait"
							name="emisor.telefono"
							label="Tel. Call Center"
							control={control}
						/>
						<CTNInput
							noFeedBack
							displayOnly
							condensed
							type="text"
							classNameField="o-grid__col-12 o-grid__col-4@portrait"
							name="emisor.email"
							label="Correo electrónico"
							control={control}
						/>
					</div>
					<div className="[ o-grid__row ] [ c-pnp-company-data__readonly-row ]">
						<CTNInput
							noFeedBack
							displayOnly
							condensed
							type="text"
							classNameField="o-grid__col-12 o-grid__col-4@portrait"
							name="emisor.direccion.descripcionTipoVia"
							label="Tipo de vía"
							control={control}
						/>
						<CTNInput
							noFeedBack
							displayOnly
							condensed
							type="text"
							classNameField="o-grid__col-12 o-grid__col-4@portrait"
							name="emisor.direccion.nombreVia"
							label="Nombre de vía"
							control={control}
						/>
					</div>
					<div className="[ o-grid__row ] [ c-pnp-company-data__readonly-row ]">
						<CTNInput
							noFeedBack
							displayOnly
							condensed
							type="text"
							classNameField="o-grid__col-4 o-grid__col-2@portrait"
							name="emisor.direccion.numeroVia"
							label="Número"
							control={control}
						/>
						<CTNInput
							noFeedBack
							displayOnly
							condensed
							type="text"
							classNameField="o-grid__col-4 o-grid__col-2@portrait"
							name="emisor.direccion.bloque"
							label="Bloque"
							control={control}
						/>
						<CTNInput
							noFeedBack
							displayOnly
							condensed
							type="text"
							classNameField="o-grid__col-4 o-grid__col-2@portrait"
							name="emisor.direccion.escalera"
							label="Escalera"
							control={control}
						/>
						<CTNInput
							noFeedBack
							displayOnly
							condensed
							type="text"
							classNameField="o-grid__col-4 o-grid__col-2@portrait"
							name="emisor.direccion.piso"
							label="Piso"
							control={control}
						/>
						<CTNInput
							noFeedBack
							displayOnly
							condensed
							type="text"
							classNameField="o-grid__col-4 o-grid__col-2@portrait"
							name="emisor.direccion.puerta"
							label="Puerta"
							control={control}
						/>
					</div>
					<div className="[ o-grid__row ] [ c-pnp-company-data__readonly-row ]">
						<CTNInput
							noFeedBack
							displayOnly
							condensed
							type="text"
							classNameField="o-grid__col-12 o-grid__col-4@portrait"
							name="emisor.direccion.codigoPostal"
							label="Código Postal"
							control={control}
						/>
						<CTNInput
							noFeedBack
							displayOnly
							condensed
							type="text"
							classNameField="o-grid__col-12 o-grid__col-4@portrait"
							name="emisor.direccion.descripcionProvincia"
							label="Provincia"
							control={control}
						/>
						<CTNInput
							noFeedBack
							displayOnly
							condensed
							type="text"
							classNameField="o-grid__col-12 o-grid__col-4@portrait"
							name="emisor.direccion.descripcionMunicipio"
							label="Municipio"
							control={control}
						/>
					</div>
				</div>
				<DetalleAlta />
				<ServiciosYNotificaciones />
			</form>
		</section>
	);
};

export default EmpresaShow;
